import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AnimatePresence } from "framer-motion";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import ProposalFooter from "./components/ProposalFooter";
import Overview from "./pages/Overview";

const Index = lazy(() => import("./pages/Index.tsx"));
const BookDemo = lazy(() => import("./pages/BookDemo.tsx"));
const AboutUs = lazy(() => import("./pages/AboutUs.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Contact = lazy(() => import("./pages/Contact.tsx"));
const ChatAI = lazy(() => import("./pages/ChatAI.tsx"));
const LeadQualification = lazy(() => import("./pages/LeadQualification.tsx"));
const WorkflowAutomation = lazy(() => import("./pages/WorkflowAutomation.tsx"));

const queryClient = new QueryClient();

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Overview />} />
              <Route path="/voice-ai" element={<Index />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/book-demo" element={<BookDemo />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/chat-ai" element={<ChatAI />} />
              <Route path="/lead-qualification" element={<LeadQualification />} />
              <Route path="/workflow-automation" element={<WorkflowAutomation />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AnimatePresence>
        </Suspense>
      </main>
      <ProposalFooter />
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AnimatedRoutes />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
